import type { TeamMember } from "@/types";
import { formatNumber } from "@/utils/format";

interface TeamStatsProps {
  members: TeamMember[];
}

const STAT_META = [
  { icon: "ri-group-line", label: "Cuentas totales", bubble: "bg-primary-500/25 text-primary-100" },
  { icon: "ri-vip-crown-2-line", label: "Administradores", bubble: "bg-accent-500/20 text-accent-200" },
  { icon: "ri-user-star-line", label: "Asesores", bubble: "bg-secondary-500/25 text-secondary-200" },
  { icon: "ri-time-line", label: "Por aprobar", bubble: "bg-accent-500/15 text-accent-100" },
];

// Resumen del equipo: cuántas cuentas hay y cómo se reparten.
const TeamStats = ({ members }: TeamStatsProps) => {
  const admins = members.filter((m) => m.role === "admin").length;
  const advisors = members.filter((m) => m.role === "asesor").length;
  const pending = members.filter((m) => m.approvalStatus === "pending").length;

  const values = [
    formatNumber(members.length),
    formatNumber(admins),
    formatNumber(advisors),
    formatNumber(pending),
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
      {STAT_META.map((meta, i) => (
        <div key={meta.label} className="glass-panel rounded-lg p-4 animate-fade-up">
          <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${meta.bubble}`}>
            <i className={`${meta.icon} text-lg`} />
          </span>
          <p className="text-[11px] text-foreground-500 mt-3">{meta.label}</p>
          <p className="text-lg md:text-xl font-heading font-extrabold text-foreground-950 mt-0.5 break-words">
            {values[i]}
          </p>
        </div>
      ))}
    </div>
  );
};

export default TeamStats;